module.exports = __webpack_public_path__ + "f234499445da32808f258e9bb284eb7b.svg";